import { useRef } from "react"

export function useRangeToggle<T extends string | number>(): (
  order: readonly T[],
  selected: ReadonlySet<T>,
  value: T,
  range: boolean,
) => Set<T> {
  const anchor = useRef<T | null>(null)

  return (order, selected, value, range) => {
    const from =
      range && selected.size > 0 && anchor.current !== null
        ? order.indexOf(anchor.current)
        : -1
    const to = order.indexOf(value)
    anchor.current = value
    const span =
      from === -1 || to === -1
        ? [value]
        : order.slice(Math.min(from, to), Math.max(from, to) + 1)
    const on = !selected.has(value)
    const next = new Set(selected)
    for (const item of span) {
      if (on) next.add(item)
      else next.delete(item)
    }
    return next
  }
}
